"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mixins = undefined;

var _utilsMain = require("./utils.main.js");

var _utilsString = require("./utils.string.js");

var _utilsDom = require("./utils.dom.js");

var _eventsjs = require("eventsjs");

var _utilsQuery = require("./utils.query.js");

var _temp_4 = _interopRequireWildcard(_utilsQuery);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _typeof(obj) { return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj; }

var mixins = _utilsMain.main.mixins = {};
/**
 * @module utils.Mixins
 */

/**
 * @class utils.Events
 * @extends Events
 */
_utilsMain.main.mixins.Events = _eventsjs.Events;

/**
 * generates a bound function collection, using an object's bind array propery
 * @class utils.Bind
 * @constructor
 */
_utilsMain.main.mixins.Bind = function () {
    var i, fn;

    /**
     * holds the generated bound function collection
     * @property bound
     * @protected
     * @type object
     */
    this.bound = function (name) {
        if (!this.bound[name]) {
            try {
                this.bound[name] = this[name].bind(this);
            } catch (e) {
                _utilsMain.main.warn("Trying to bind undefined method " + name);
                return;
            }
        }

        return this.bound[name];
    };

    if (!this.bind) return;

    for (i = 0; fn = this.bind[i]; i++) {
        this.bound(fn);
    }
};

/**
 *  A simple mixin for managing an options argument. Mixin uses the defaultOptions property to identify default options.
 *  Mixin also automatically identify on* properties as events and assigns them
 *
 *  @class utils.Options
 *  @constructor
 *
 */
_utilsMain.main.mixins.Options = function Options() {
    var key;
    this.options = {};

    for (key in this.defaultOptions) {
        if (this.defaultOptions.hasOwnProperty(key)) {
            this.options[key] = this.defaultOptions[key];
        }
    } /**
       * @method setOptions
       * @param {object} options
       * @chainable
       */
    this.setOptions = function (options) {
        var key;
        if ((typeof options === "undefined" ? "undefined" : _typeof(options)) !== 'object' || options === null) return this;
        for (key in options) {
            if (options.hasOwnProperty(key)) {
                if (key in this.options) this.options[key] = options[key];
                if (/^on[A-Z][a-zA-Z]+/.test(key) && this.addEvent && typeof options[key] == 'function') {
                    this.addEvent(_utilsMain.main.mixins.Events.removeOn(key), options[key]);
                }
            }
        }return this;
    };

    /**
     * this property will be used to identify default options
     * @property defaultOptions
     * @protected
     */
};
/**
 * this method acts like merge, only that it only merges properties of the original object
 *
 * _Creates a new object rather than actually merge_
 *
 * @method setOptions
 * @static
 * @param {Object} defaults a map of default properties
 * @param {Object} options a map of values to merge
 *
 * @return {Object} new merged object
 */
_utilsMain.main.mixins.Options.setOptions = function (defaults, options) {
    var opts = {},
        key;

    for (key in defaults) {
        if (typeof options[key] != 'undefined') {
            opts[key] = options[key];
        } else {
            opts[key] = defaults[key];
        }
    }return opts;
};

/**
 * This class provides a simple means to create a tab interface. Can function as a standalone or a mixin
 *
 * ###This Mixin requires some structure in order to work properly
 *  * a tabs list (identified by a 'tabs' class)
 *  * each tab should have a 'tab' class and should have a 'data-target' attribute indicating a classname of a target pane
 *
 * ###CSS Classes used by the mixin:
 *  * `.tabs`: tabs container
 *  * `.tab`: a tab
 *  * `.panes`: panes container
 *  * `.pane`: a pane
 *  * `.current`: will be use to indicate current tab/pane
 *
 *
 *  @class utils.Tabs
 *  @constructor
 *  @param element el the container of the interface
 */

/**
 * fired when a tab is selected
 * @event tabSelect
 * @param args
 *  @param {Element} args.tab the selected tab
 *  @param {Element} args.pane the selected pane
 */
_utilsMain.main.mixins.Tabs = function (el) {

    var $this = this,
        evType = 'iclick',
        tab;

    function tabClick(e) {
        $this.setCurrent(e.target);
        e.stopPropagation();
    }

    this.$tab_callbacks = {};

    /**
     * sets the current tab
     * @method setCurrent
     *
     * @param {String|Element} tab which tab to set to current
     *
     * @chainable
     */
    this.setCurrent = function (el) {
        var cls, selector, target, tab, old_cb, new_cb;

        el = typeof el == 'string' ? this.$tabElements.tabContainer.querySelector('.' + el) : el;

        el = _utilsMain.main.delegate(el, 'tab', this.$tabElements.tabContainer);

        if (!el) return this;

        cls = el.dataset ? el.dataset.target : el.getAttribute('data-target');
        selector = '.pane.' + cls;
        target = this.$tabElements.paneContainer.querySelector(selector);

        if (!target) return this;

        if (this.currentTab) {
            _utilsDom.dom.removeClass(this.currentTab, 'current');
            _utilsDom.dom.removeClass(this.currentPane, 'current');
            if (this.current_class) _utilsDom.dom.removeClass(this.currentTab, this.current_class);
        }

        this.currentTab = el;

        _utilsDom.dom.addClass(el, 'current');
        _utilsDom.dom.addClass(target, 'current');

        if (this.current_class) _utilsDom.dom.addClass(el, this.current_class);

        new_cb = this.$tab_callbacks[target.getAttribute('data-pane-name')];

        if (this.currentPane) {
            old_cb = this.$tab_callbacks[this.currentPane.getAttribute('data-pane-name')];
        }

        this.hidePane && this.currentPane && this.hidePane(this.currentPane);
        this.showPane && this.showPane(target);
        this.currentPane = target;

        old_cb && old_cb(false);
        new_cb && new_cb(true);

        this.fireEvent && this.fireEvent('tabSelect', { tab: el, pane: target, name: target.getAttribute('data-pane-name') });

        return this;
    };

    /**
     * @method addTab
     *
     * @param {object} params
     * @param {string} params.name a unique tab name
     * @param {string} params.text a text to set to the tab
     * @param {Element} params.pane an element to use as pane content
     * @param {number}   [params.index]
     * @param {Function} [params.stateChange] this callback will be called whenever the tab is shown or hidden (will be passed a boolean parameter indicating new state)
     */
    this.addTab = function (params) {
        var li = document.createElement('li'),
            name = params.name,
            text = params.text,
            el = params.pane,
            index = params.index || 1000,
            callback = params.stateChange;

        li.className = 'tab ' + name;
        li.appendChild(document.createTextNode(text));
        li.setAttribute('data-target', name);
        li.setAttribute('data-index', index);

        if (typeof el == 'string') {
            text = document.createTextNode(el);
            el = document.createElement('div');
            el.appendChild(text);
        }

        el.className += ' pane ' + name;

        el.setAttribute('data-pane-name', name);
        el.setAttribute('data-pane-index', index);

        _utilsDom.dom.insertByProp(li, 'data-index', this.$tabElements.tabContainer);
        _utilsDom.dom.insertByProp(el, 'data-pane-index', this.$tabElements.paneContainer);

        this.has_tabs = true;

        this.$tab_callbacks[name] = callback;

        if (this.default_tab == name || !this.currentPane) this.setCurrent(li);

        return li;
    };

    this.dettachTabs = function () {
        _utilsDom.dom.removeEvent(this.$tabElements.tabContainer, evType, tabClick);
    };

    /**
     * takes care of tab destruction
     * @method detachTabs
     */
    this.detachTabs = this.dettachTabs;

    this.attachTabs = function () {
        _utilsMain.main.addEvent(this.$tabElements.tabContainer, 'iclick', tabClick);
    };

    this.$tabElements = {
        container: el,
        tabContainer: el.querySelector('.tabs'),
        paneContainer: el.querySelector('.panes')
    };

    /**
     * override this method to get an indication when a pane is shown
     * @method showPane
     * @param {Element} pane
     */
    /**
     * override this method to get an indication when a pane is hidden
     * @method hidePane
     * @param {Element} pane
     */

    this.setCurrent(_utilsDom.dom.getFirstChild(this.$tabElements.tabContainer));
    this.attachTabs();
};

/**
 * This mixin takes care of preventing scrolling events from bubbling down
 * @class utils.Scroller
 * @constructor
 * @param {Element} element root element to stop event propagation
 */
_utilsMain.main.mixins.Scroller = function (element) {
    function handle(e) {
        e.stopPropagation();
    }

    element.addEventListener('mousewheel', handle, false);
    element.addEventListener('MozMousePixelScroll', handle, false);
    element.addEventListener('scroll', handle, false);

    /**
     * this method takes care of mixin destruction
     * @method destroyScroller
     */
    this.destroyScroller = function () {
        element.removeEventListener('mousewheel', handle, false);
        element.removeEventListener('MozMousePixelScroll', handle, false);
        element.removeEventListener('scroll', handle, false);
    };
};

_utilsMain.main.mixins.Attacher = function () {
    var old_attach = this.attach,
        old_detach = this.detach;

    this.attach = function attach() {
        var i, item, target, fn, type;

        if (!this.attach_list) return;

        for (i = 0; item = this.attach_list[i]; i++) {
            if (item.length > 2) {
                target = this.elements[item[0]];
                type = item[1];
                fn = this.bound[item[2]];
            } else {
                target = this.element;
                type = item[0];
                fn = this.bound[item[1]];
            }

            if (!target) continue;

            target.addEventListener(type, fn, false);
        }

        if (old_attach) {
            old_attach.apply(this);
        }
    };

    this.detach = function detach() {
        var i, item, target, fn, type;

        if (!this.attach_list) return;

        for (i = 0; item = this.attach_list[i]; i++) {
            if (item.length > 2) {
                target = this.elements[item[0]];
                type = item[1];
                fn = this.bound[item[2]];
            } else {
                target = this.element;
                type = item[0];
                fn = this.bound[item[1]];
            }

            if (!target) continue;

            target.removeEventListener(type, fn, false);
        }

        if (old_detach) {
            old_detach.apply(this);
        }
    };
};

/**
 * This mixin takes care of prefetching resources
 * @class utils.Prefethcer
 */
/**
 * a list of resources to prefetch
 * @property prefetch
 * @type {array}
 */
_utilsMain.main.mixins.Prefetcher = function Prefetcher() {
    if (!this.prefetch) return;

    function run() {
        _utilsMain.main.prefetch.apply(null, this.prefetch);
    }

    if (this.bridge) {
        this.bridge.addEvent('Book.load', run.bind(this));
    } else {
        run.call(this);
    }
};

/**
 * KeyNav mixin used to allow user navigating (class toggle) between list children.
 *
 * @class utils.KeyNav
 * @constructor
 * @param element the element to add key navigation to
 *
 */

/**
 * add this property to your object before applying the mixin to pass it as options.
 *
 * Possible options are:
 *
 * * `className` : custom class name to mark selected element
 * * `onSelect`  : a callback to call when an element is selected
 * * `event_type` (default is keydown)
 * * `use_capture` (default is false)
 *
 * @property keyNavOptions
 * @type object
 */
_utilsMain.main.mixins.KeyNav = function (element) {
    //set default className if not provided
    var opt,
        options = {
        target: element,
        class_name: 'selected',
        event_type: 'keydown',
        use_capture: false
    };

    //override default options
    if (this.keyNavOptions) {
        for (opt in this.keyNavOptions) {
            options[opt] = this.keyNavOptions[opt];
        }
    }

    function eventHandler(e) {
        var current,
            closeSibling,
            defaultChild,
            keysList = [_utilsDom.dom.keyCodes.UP, _utilsDom.dom.keyCodes.DOWN];

        if (keysList.indexOf(e.keyCode) === -1 || element.childNodes.length === 0 || options.prevent && options.prevent(e) === true) {
            return;
        }

        e.stopPropagation();

        if (e.keyCode === _utilsDom.dom.keyCodes.DOWN) {
            closeSibling = 'nextSibling';
            defaultChild = 'firstChild';
        } else if (e.keyCode === _utilsDom.dom.keyCodes.UP) {
            closeSibling = 'previousSibling';
            defaultChild = 'lastChild';
        }

        current = _utilsDom.dom.query('.' + options.class_name, element)[0];

        if (!current) {
            if (element.firstChild) {
                current = element[defaultChild];
                _utilsDom.dom.addClass(current, options.class_name);
            }
        } else if (current[closeSibling]) {
            _utilsDom.dom.removeClass(current, options.class_name);
            current = current[closeSibling];
            _utilsDom.dom.addClass(current, options.class_name);
        } else {
            _utilsDom.dom.removeClass(current, options.class_name);
            current = element[defaultChild];
            _utilsDom.dom.addClass(current, options.class_name);
        }

        if (options.onSelect) {
            options.onSelect(current);
        }
    }
    options.target.addEventListener(options.event_type, eventHandler, options.use_capture);

    this.addEvent('destroy', function () {
        options.target.removeEventListener(options.event_type, eventHandler, options.use_capture);
    });
};

/**
 * This mixin provides a utility function for easy event delegation handling
 * @class utils.Delegate
 * @constructor
 * @param {Element} el target element for all delegations
 *
 * @example 
 *      utils.Delegate.call(this,this.element)
 */
_utilsMain.main.mixins.Delegate = function (el) {
    var capture = { blur: true, focus: true };

    /**
     * a reference for delegated element
     * @property $delegated_element
     * @type {Element}
     * @private
     */
    this.$delegated_element = el;
    /**
     * a holder for selector maps
     * @property $delegated_maps
     * @type {Object}
     * @private
     */
    var maps = this.$delegated_maps = {};

    var $this = this;

    function delegate(e) {
        var el = e.target,
            type = e.type,
            map = maps[type],
            selector,
            fn;

        for (selector in map) {
            if (!_utilsDom.dom.matchesSelector(el, selector)) continue;

            fn = map[selector];

            if (typeof fn == 'string') {
                fn = $this.bound(fn);
            }

            try {
                if (fn(e) === false) break;
            } catch (e) {
                console.error("Delegated event error", e);
            }
        }
    }

    /**
     * delegates a map of selectors to a specific event
     * @method delegateEvent
     * @param {string} type
     * @param {Object} a selector => function map. 
     *
     * @example
     *      this.delegateEvent('iclick',{
     *          '.note.editable' : this.bound.editNote
     *          '.handle.close'  : this.bound.close
     *      });
     *
     * @chainable
     */
    this.delegateEvent = function (type, map) {
        this.$delegated_maps[type] = _utilsMain.main.merge(this.$delegated_maps[type] || {}, map);

        if (!this.$delegated_maps[type]) {
            this.$delegated_element.addEventListener(type, delegate, !!capture[type]);
        }

        return this;
    };
    this.addEvent('destroy', (function () {
        var type;
        for (type in this.$delegated_maps) {
            this.$delegated_element.removeEventListener(type, delegate, !!capture[type]);
        }

        this.$delegated_maps = null;
        this.$delegated_element = null;
        this.delegateEvent = null;
    }).bind(this));
};

_utilsMain.main.mixins.Generator = function Generator() {
    var template = this['g:template'],
        elements = this['g:elements'],
        getData = this['g:getData'],
        data = getData ? this['g:getData']() : {};

    switch (typeof template === "undefined" ? "undefined" : _typeof(template)) {
        case 'string':
            this.element = _utilsDom.dom.toElement(_utilsMain.main.template(template, data), {}, true);
            break;
        case 'function':
            this.element = this['g:template'](data);
            break;
    }

    if (this.$name) {
        _utilsDom.dom.addClass(this.element, this.$name);
    }

    if (elements) {
        this.elements = this.element.getElements(elements);
    }
};

exports.mixins = mixins;


//////////////////
// WEBPACK FOOTER
// ./~/ereader-core/dist/utils.mixins.js
// module id = 151
// module chunks = 0